import { render, staticRenderFns } from "./EditingDFTable.vue?vue&type=template&id=130ac6ca&"
import script from "./EditingDFTable.vue?vue&type=script&lang=js&"
export * from "./EditingDFTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports